import React from 'react';
import { DrawerBody } from 'components/UI/V3/Drawer/Body/DrawerBody';
import { Drawer } from 'components/UI/V3/Drawer/Drawer';
import { DrawerHeader } from 'components/UI/V3/Drawer/Header/DrawerHeader';
import { IconCard } from 'components/UI/V3/IconCard/IconCard';
import { TASK_TYPE_OPTIONS } from 'components/Tasks/taskTypes';
import styles from './TaskTypeSelector.module.scss';

interface TaskTypeSelectorProps {
    onSelectType: (typeId: string) => void;
    onClose: () => void;
}

export const TaskTypeSelector: React.FC<TaskTypeSelectorProps> = ({ onSelectType, onClose }) => {
    return (
        <Drawer onClose={onClose}>
            <DrawerHeader title="Add Task" />
            <DrawerBody className={styles.grid}>
                {TASK_TYPE_OPTIONS.map(option => (
                    <IconCard
                        key={option.id}
                        title={option.label}
                        icon={option.icon}
                        backgroundColor={option.color}
                        onClick={option.disabled ? undefined : () => onSelectType(option.id)}
                    />
                ))}
            </DrawerBody>
        </Drawer>
    );
};

export default TaskTypeSelector;
